import React, {Component, createElement} from "react";
import { BrowserRouter as Router, Route, Switch} from "react-router-dom";
import queryString from 'query-string';
import Helmet from "react-helmet";

//コンポーネント読み込み
import CommonLogin from './CommonLogin';
import Logout from './Logout';
import PwdChange from './PwdChange';
import PwdReset from './PwdReset';
import PinChange from './PinChange';
import Error from './Error';
import SnsRelationSelect from './SnsRelationSelect';
import SnsRelation from './SnsRelation';
import SNSSetting from './SNSSetting';
import OtpChange from './OtpChange';
import MobilenumberChange from './MobilenumberChange';
import MobilenumberRegistGuide from './MobilenumberRegistGuide';
import DenyError from './DenyError';

// ヘッダ・フッタ生成関数：CSSタグ生成
const createCSSTag = ( fileName ) => {
  const cssLink = document.createElement('link');
  cssLink.rel = 'stylesheet';
  cssLink.href = process.env.PUBLIC_URL + '/css/' + fileName;
  return cssLink;
}
// ヘッダ・フッタ生成関数：Copyright生成
const createCopyright = () => {
  const copyright = document.createElement('p');
  copyright.className = 'f-inner_txt';
  const copyrightText =  document.createElement('small');
  copyrightText.lang = 'en';
  copyrightText.innerHTML = 'Copyright&copy;Japan Airlines. All rights reserved.';
  copyright.appendChild(copyrightText);
  return copyright;
}
// ヘッダ・フッタ生成関数：リンクタグ生成
const createLinkTag = ( imgFileName, altName, hrefURL, linkName ) => {
  const liLink = document.createElement('li');
  const imgTag = document.createElement('img');
  imgTag.src = process.env.PUBLIC_URL + '/img/' + imgFileName;
  imgTag.alt = altName;
  imgTag.className = 'icon-blank';
  const aTag = document.createElement('a');
  aTag.href = hrefURL;
  aTag.target = 'otherwindow';
  aTag.textContent = linkName;
  liLink.appendChild(imgTag);
  liLink.appendChild(aTag);
  liLink.innerHTML = `${imgTag.outerHTML} ${aTag.outerHTML}`;
  return liLink;
}

class Parent extends Component {

  render() {
    let params = {};
    let snsAssociateParams = {};

    // クエリパラメータが存在した場合
    if(Object.keys(this.props.qs).length) {
    
      // 必要なもののみ取得しコンポーネントへ渡す
      let tempParams = {};
      if (this.props.qs.AUTHENTICATED) {
        tempParams = queryString.parse(this.props.qs.AUTHENTICATED.substring(this.props.qs.AUTHENTICATED.indexOf("?") + 1));
      } 
      else {
        tempParams = this.props.qs;
      }

      params = {
        SITE_ID: this.props.qs.SITE_ID,
        AUTH_TYPE: this.props.qs.AUTH_TYPE,
        AUTHENTICATED: this.props.qs.AUTHENTICATED, 
        MESSAGE_AUTH: this.props.qs.MESSAGE_AUTH,
        ERROR_MESSAGE: this.props.qs.ERROR_MESSAGE,
        REGIST_TRANS_TYPE: this.props.qs.registTransType,
        DESIGN_TYPE: tempParams.design,   
        LANGUAGE_TYPE: tempParams.lang,   
        GUEST_URL: tempParams.guest_url
      }

      // 画面デザイン
      if (params.DESIGN_TYPE) {
        sessionStorage.setItem("design", params.DESIGN_TYPE);
      } else {
        if (!sessionStorage.getItem("design")) {
          if(localStorage.getItem("design")){
            sessionStorage.setItem("design",localStorage.getItem("design"));
            localStorage.removeItem("design");
          }else{
            sessionStorage.setItem("design", process.env.REACT_APP_DESIGN_DEFAULT_VALUE);
          }
        }
      }
      
      // 画面表示言語
      let validLang = ['ja', 'en', 'it', 'de', 'fr', 'es', 'ru', 'zhcn', 'zhtw', 'zhhk', 'ko', 'th', 'vi', 'id'];
      if (params.LANGUAGE_TYPE && validLang.includes(params.LANGUAGE_TYPE)) {
        sessionStorage.setItem("lang", params.LANGUAGE_TYPE);
      } else {
        if (!sessionStorage.getItem("lang")) {
          if(localStorage.getItem("lang")){
            sessionStorage.setItem("lang",localStorage.getItem("lang"));
            localStorage.removeItem("lang");
          }else{
            sessionStorage.setItem("lang", process.env.REACT_APP_LANGUAGE_DEFAULT_VALUE);
          }
        }
      }

      // 画面表示言語により対応する言語ファイルを読み取り、セッションに保存する
      let messageJson = "";
      messageJson = require('../jsonFile/message_' + sessionStorage.getItem("lang") + '.json');
      sessionStorage.setItem("messageList", JSON.stringify(messageJson)); 

      // SNS連携TID
      if ( this.props.qs.SNS_ASSOCIATE_TID )
      {
        snsAssociateParams = {
          SNS_ASSOCIATE_TID: this.props.qs.SNS_ASSOCIATE_TID
        }
        params.SNS_ASSOCIATE_TID = snsAssociateParams.SNS_ASSOCIATE_TID;
        sessionStorage.snsAssociateParams = JSON.stringify(snsAssociateParams);
      }
      else{
        if(sessionStorage.snsAssociateParams){
          snsAssociateParams = JSON.parse(sessionStorage.snsAssociateParams);
          params.SNS_ASSOCIATE_TID = snsAssociateParams.SNS_ASSOCIATE_TID;
        }
      }
    }
    // クエリパラメータが存在しない場合
    else {
      // セッションストレージに画面デザインが存在しない場合
      if (!sessionStorage.getItem("design")) {
        // ローカルストレージに画面デザインが存在する場合
        if(localStorage.getItem("design")){
          sessionStorage.setItem("design",localStorage.getItem("design"));
          localStorage.removeItem("design");
        }else{
          sessionStorage.setItem("design", process.env.REACT_APP_DESIGN_DEFAULT_VALUE);
        }
      }

      // セッションストレージに画面表示言語が存在しない場合
      if (!sessionStorage.getItem("lang")) {
        let messageJson = "";
        // ローカルストレージに画面表示言語が存在する場合
        if(localStorage.getItem("lang")){
          sessionStorage.setItem("lang",localStorage.getItem("lang"));
          localStorage.removeItem("lang");
          messageJson = require('../jsonFile/message_' + sessionStorage.getItem("lang") + '.json');
        }else{
          sessionStorage.setItem("lang", process.env.REACT_APP_LANGUAGE_DEFAULT_VALUE);
          messageJson = require('../jsonFile/message_' + process.env.REACT_APP_LANGUAGE_DEFAULT_VALUE + '.json');
        }
        sessionStorage.setItem("messageList", JSON.stringify(messageJson));
      }

      // SNS連携TID
      if(sessionStorage.snsAssociateParams){
        snsAssociateParams = JSON.parse(sessionStorage.snsAssociateParams);
        params.SNS_ASSOCIATE_TID = snsAssociateParams.SNS_ASSOCIATE_TID;
      }
    }

    // デザイン値の取得
    let design = sessionStorage.getItem("design"); 

    // JOHNデザインの場合、言語判定・ヘッダ/フッタ切替を行う
    if (design === "JH001N" || design === "JH004N") {

      // 言語設定の取得
      let lang = sessionStorage.getItem("lang"); 

      // 言語設定がja・en以外の場合、enに設定する
      if (lang !== "ja" && lang !== "en"){
        let messageJsonEN = require('../jsonFile/message_en.json');
        sessionStorage.setItem("lang", "en");
        sessionStorage.setItem("messageList", JSON.stringify(messageJsonEN));       
      }

      // header・footer要素を取得する
      const headerDiv = document.getElementById('header'); // 親のdivを取得
      const hInnerDiv = headerDiv.querySelector('.h-inner'); // h-innerのクラスを取得
      const footerDiv = document.getElementById('footer'); // 親のdivを取得
      const fInnerDiv = footerDiv.querySelector('.f-inner'); // f-innerのクラスを取得

      // 共通項目の取得
      const headTag = document.head; //headタグ(CSS切替用)
      let messageList = JSON.parse(sessionStorage.getItem('messageList')); //文言リスト

      /* ======================== Header Del ======================== */
      // 一度、JALデザインのheaderタグをすべて削除し、以下の状態にする
      // <header id="header">
      //   <div class="h-inner">
      //   </div><!-- /h-inner -->
      // </header>

      const cssLinks = document.querySelectorAll('link[rel="stylesheet"]');

      // CSS リンク要素を配列に保持
      const linkElements = Array.from(cssLinks);

      // 配列から各リンク要素を削除
      linkElements.forEach(element => {
        const hrefText = element.getAttribute('href');
        if (hrefText.indexOf('index_5.css') !== -1 || hrefText.indexOf('fsi_add_2.css') !== -1) {
          document.head.removeChild(element);
        }
      });

      // headerのrole属性及び子要素の削除
      headerDiv.removeAttribute('role');
      while (hInnerDiv.firstChild) {
        hInnerDiv.removeChild(hInnerDiv.firstChild);
      }
      /* ======================== Header Del ======================== */

      /* ======================== Footer Del ======================== */
      // 一度、JALデザインのfooterタグをすべて削除し、以下の状態にする
      // <footer id="footer">
      // <div class="f-inner">
      // </div><!-- /f-inner -->

      // footerのrole属性及び子要素の削除
      fInnerDiv.removeAttribute('role');
      while (fInnerDiv.firstChild) {
        fInnerDiv.removeChild(fInnerDiv.firstChild);
      }
      /* ======================== Footer Del ======================== */

      /* ======================== CSS ======================== */
      headTag.appendChild(createCSSTag('index_john.css'));
      /* ======================== CSS ======================== */

      /* ======================== Header ======================== */
      // URL定義
      const manualLink = 'https://www.jal.co.jp/jalonline/john/v25/user/user_manual2/';
      const announcementLink = 'https://www.jal.co.jp/jp/ja/jalonline/system-info/';

      // hInnerDivのid指定
      hInnerDiv.id = 'top';

      // メインロゴ部分の生成
      const logo1 = document.createElement('p');
      logo1.className = 'h-logo';
      const img1 = document.createElement('img');
      img1.src = process.env.PUBLIC_URL + '/img/logo_john.png';
      img1.alt = 'JAL ONLINE';
      logo1.appendChild(img1);

      // リンク部分の生成
      const headerLink = document.createElement('ul');
      headerLink.className = 'h-nav';
      headerLink.appendChild(createLinkTag('icon_blank_001.png', messageList.common.guideNewWindow, manualLink, messageList.header.linkManual));
      headerLink.appendChild(createLinkTag('icon_blank_001.png', messageList.common.guideNewWindow, announcementLink, messageList.header.linkAnnouncement));

      // header要素にメインロゴ・リンクを設定
      hInnerDiv.appendChild(logo1);
      hInnerDiv.appendChild(headerLink);
      /* ======================== Header ======================== */

      /* ======================== Footer ======================== */
      // URL定義
      const maintenanceLink = 'https://www.jal.co.jp/jalonline/system_maintenance.html';
      const inquiryLink = 'https://www.jal.co.jp/jalonline/manual/#inquiry';
      const securityLink = 'https://www.jal.co.jp/jalonline/rule/security.html';

      // ulタグの生成
      const links = document.createElement('ul');
      links.className = 'f-inner_list';

      // 各liタグを生成し、ulタグに追加
      links.appendChild(createLinkTag('icon_blank_002.png', messageList.common.guideNewWindow, maintenanceLink, messageList.footer.linkMaintenance));
      links.appendChild(createLinkTag('icon_blank_002.png', messageList.common.guideNewWindow, inquiryLink, messageList.footer.linkContact));
      links.appendChild(createLinkTag('icon_blank_002.png', messageList.common.guideNewWindow, securityLink, messageList.footer.linkPrivacy));

      // Copyrightの設定
      fInnerDiv.appendChild(createCopyright());
      // リンク部の設定
      fInnerDiv.appendChild(links);
      /* ======================== Footer ======================== */
    }

    return (
      <section className="section">
        <Helmet
          htmlAttributes={{
            lang: window.changeLang(sessionStorage.getItem("lang")),
          }} >  
        </Helmet>
        <Router>
          <Switch>
            <Route path={`${process.env.REACT_APP_CONTEXT_PATH}/login`} render={ (props) => <CommonLogin params= {params} {...props}/> }/>
            <Route path={`${process.env.REACT_APP_CONTEXT_PATH}/logout`} render={ () => <Logout params= {params} /> }/>
            {(process.env.REACT_APP_USE_PWD_CHANGE === "true") && (
              <Route path={`${process.env.REACT_APP_CONTEXT_PATH}/menu/pwd_change`} render={ (props) => <PwdChange params= {params} {...props}/> }/>
            )}
            {(process.env.REACT_APP_USE_PWD_RESET === "true") && (
            <Route path={`${process.env.REACT_APP_CONTEXT_PATH}/pwd_reset`} render={ (props) => <PwdReset params= {params} {...props}/> }/>
            )}
            {(process.env.REACT_APP_USE_PIN_CHANGE === "true") && (
            <Route path={`${process.env.REACT_APP_CONTEXT_PATH}/pin_change`} render={ (props) => <PinChange params= {params} {...props}/> }/>
            )}         
            {(process.env.REACT_APP_USE_SNS_RELATION === "true") && (
              <Route path={`${process.env.REACT_APP_CONTEXT_PATH}/sns_relation_select`} render={ () => <SnsRelationSelect params= {params} /> }/>
            )}
            {(process.env.REACT_APP_USE_SNS_RELATION === "true") && (
              <Route path={`${process.env.REACT_APP_CONTEXT_PATH}/sns_relation`} render={ () => <SnsRelation params= {params} /> }/>
            )}
            {(process.env.REACT_APP_USE_SNS_SETTING === "true") && (
              <Route path={`${process.env.REACT_APP_CONTEXT_PATH}/menu/sns`} render={ () => <SNSSetting params= {params} /> }/>
            )}
            {(process.env.REACT_APP_USE_OTP_CHANGE === "true") && (
              <Route path={`${process.env.REACT_APP_CONTEXT_PATH}/menu/otp_auth`} render={ (props) => <OtpChange params= {params} {...props}/> }/>
            )}
             {(process.env.REACT_APP_USE_MOBILENUMBER_CHANGE === "true") && (
              <Route path={`${process.env.REACT_APP_CONTEXT_PATH}/mobilenumber_change`} render={ (props) => <MobilenumberChange params= {params} {...props}/> }/>
            )}
            <Route path={`${process.env.REACT_APP_CONTEXT_PATH}/error`} render={ (props) => <Error params= {params} {...props}/> }/> 
            <Route path={`${process.env.REACT_APP_CONTEXT_PATH}/mobilenumber_register_guide`} render={ (props) => <MobilenumberRegistGuide params= {params} {...props}/> }/> 
            <Route path={`${process.env.REACT_APP_CONTEXT_PATH}/deny_error`} render={ (props) => <DenyError params= {params} {...props}/> }/> 
            <Route component={Error} />
          </Switch>
        </Router>
      </section>
    )
  }
}

export default Parent